<template>
    <div :class="{'circle-loader': true, 'load-complete': finished}">
        <div class="checkmark draw"></div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
    props: ['finished'],
});
</script>

<style lang="scss">
@import '../../sass/components/circle-loader';
</style>
